import React from 'react';
import classNames from 'classnames';
import { isEmpty } from 'lodash';
import { Spinner } from 'ui';
import ContentHeader from './ContentHeader';
import ContentDescription from './ContentDescription';
import StepOrder from './StepOrder';
import StepsGroup from './PathContentSteps';
import Warning from './Warning';
import Step from './PathContentStep';

const ConditionalRender = ({ on, children }) => {
  if (!on) return false;
  return children.length > 1 ? <div>{children}</div> : children;
};

const getContainerClassName = props =>
  classNames('PathContent', {
    'PathContent--subContent': props.subPath,
    'PathContent--disabled': props.warning,
  });

const PathBody = props => (
  <div className={getContainerClassName(props)}>
    <ContentHeader {...props} />
    <div className="PathContent-body">
      <ConditionalRender on={props.description}>
        <ContentDescription description={props.description} />
      </ConditionalRender>
      <ConditionalRender on={!props.loading}>
        <ConditionalRender on={!props.warning}>
          <StepOrder enforcedOrder={props.enforcedOrder} />
        </ConditionalRender>
        <ConditionalRender on={props.warning}>
          <Warning message={props.warning} />
        </ConditionalRender>
        <ConditionalRender on={!isEmpty(props.contents)}>
          <StepsGroup contents={props.contents}>
            {step => <Step key={step.id} {...step} />}
          </StepsGroup>
        </ConditionalRender>
      </ConditionalRender>
      <ConditionalRender on={props.loading}>
        <Spinner />
        <span className="ml-8 c-brand-gray-darker">Loading...</span>
      </ConditionalRender>
    </div>
  </div>
);

export default PathBody;
